import { render, staticRenderFns } from "./ClientListComponent.vue?vue&type=template&id=cd64888e&"
import script from "./ClientListComponent.vue?vue&type=script&lang=js&"
export * from "./ClientListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports